import { apiSlice } from "../../app/api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/auth/token/',
                method: 'POST',
                body: { ...credentials }
            })
        }),
        getMe: builder.query({
            query: () => '/api/v1/accounts/users/me/',
        }),
    })
})

export const {
    useLoginMutation,
    useGetMeQuery
} = authApiSlice